export default [
	{
		path: "/client",
		exact: true,
		component: "Home",
		load: true,
	},
];
